// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"bab7a68b","816":"bab7a68b"}[chunkId] + ".chunk.css";
};